import service from '@/utils/server';

const modName = '/bd/trackRejectApproverEmail/';
//详情
export const detailInfo = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};
//审批确认
export const submitApproval = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/reject/rejectApprovalShow/api/index.js